import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FocusTarget } from 'shared/models/focus/focus.model';
import { slideInFromBottomAnimation } from 'shared/components/work-widget-control-panel/scss/slide-in-from-bottom-animation';

@Component({
  selector: 'app-more-actions-panel',
  templateUrl: './more-actions-panel.component.html',
  styleUrls: ['./more-actions-panel.component.scss'],
  animations: [slideInFromBottomAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MoreActionsPanelComponent implements OnChanges {
  @Input()
  isOpen: boolean;
  @Input()
  openFocusTarget?: FocusTarget;
  @Output()
  readonly togglePanel = new EventEmitter<void>();

  @HostListener('keydown.escape')
  onKeyboardClose(): void {
    this.togglePanel.emit();
  }

  ngOnChanges({ isOpen }: SimpleChanges): void {
    if (isOpen && isOpen.currentValue) {
      setTimeout(() => {
        this.openFocusTarget?.focus();
      }, 0);
    }
  }
}
